import { render, staticRenderFns } from "./productNameCard.vue?vue&type=template&id=1ecca6f0&scoped=true&"
import script from "./productNameCard.vue?vue&type=script&lang=js&"
export * from "./productNameCard.vue?vue&type=script&lang=js&"
import style0 from "./productNameCard.vue?vue&type=style&index=0&id=1ecca6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecca6f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecca6f0')) {
      api.createRecord('1ecca6f0', component.options)
    } else {
      api.reload('1ecca6f0', component.options)
    }
    module.hot.accept("./productNameCard.vue?vue&type=template&id=1ecca6f0&scoped=true&", function () {
      api.rerender('1ecca6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/crudApp/productNameCard.vue"
export default component.exports